export function hasPassthroughVariableValues(unit: string, min?: number, max?: number) {
  const unitIndicatesPassthrough = (unit: string): boolean => {
    const parts = unit.split('_');
    if (parts.length === 0 || parts.length % 2 !== 0) {
      return false;
    }
    const half = parts.length / 2;
    for (let i = 0; i < half; i++) {
      if (parts[i] !== parts[i + half]) {
        return false;
      }
    }
    return true;
  };
  return min === 1 && max === 1 && unitIndicatesPassthrough(unit);
}
